import type { SVGProps } from 'react';

const SvgRefundPoint = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill='none'
    height='1em'
    viewBox='0 0 24 24'
    width='1em'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <defs>
      <mask id='hole-mask-2'>
        <rect fill='white' height='24' width='24' x='0' y='0' />

        <path
          d='M11.789 13.813c-.063 0-.105.015-.127.045-.02.022-.031.063-.031.123v1.645c0 .104-.025.179-.074.224-.042.044-.112.067-.21.067h-1.274c-.091 0-.161-.023-.21-.067a.349.349 0 0 1-.064-.224V8.374c0-.104.021-.179.063-.223.05-.045.12-.068.211-.068h2.474c2.168 0 3.252.944 3.252 2.832 0 .955-.284 1.678-.852 2.17-.569.485-1.393.728-2.474.728h-.684Zm0-3.94c-.063 0-.105.016-.127.046-.02.022-.031.063-.031.123v1.813c0 .06.01.104.031.134.021.022.064.033.127.033h.684c.47 0 .825-.09 1.063-.268.246-.187.369-.463.369-.828 0-.366-.12-.63-.358-.795-.232-.171-.59-.257-1.074-.257h-.684Z'
          fill='black'
        />
      </mask>
    </defs>

    <path
      d='M17 7.75c-.19 0-.38-.07-.53-.22a.754.754 0 0 1 0-1.06l2.05-2.05C16.76 2.92 14.49 2 12 2 6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10c0-2.49-.92-4.76-2.42-6.52l-2.05 2.05c-.15.15-.34.22-.53.22Z'
      fill='currentColor'
      mask='url(#hole-mask-2)'
    />
    <path
      d='M22.69 1.71a.782.782 0 0 0-.41-.41.717.717 0 0 0-.29-.06h-4c-.41 0-.75.34-.75.75s.34.75.75.75h2.19l-1.67 1.67c.38.33.73.68 1.06 1.06l1.67-1.67V6c0 .41.34.75.75.75s.75-.34.75-.75V2c.01-.1-.01-.19-.05-.29Z'
      fill='currentColor'
    />
  </svg>
);
export default SvgRefundPoint;
